import React, { useState, useEffect } from 'react';
import { userQuotaAPI } from '../../services/userQuotaAPI';
import { getQuotaStatus, getQuotaClasses } from '../../config/appConfig';

const UserQuotaDisplay = ({ refreshTrigger }) => {
  const [quotaInfo, setQuotaInfo] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadQuotaInfo = async () => {
    try {
      const result = await userQuotaAPI.getUserQuota();
      
      if (result.success) {
        const formatted = userQuotaAPI.formatQuotaInfo(result.data);
        setQuotaInfo(formatted);
      } else {
        // Si es error de autenticación, no mostrar información de cuota
        if (result.statusCode === 401) {
          setQuotaInfo(null);
        } else {
          // Para otros errores, podrías mostrar un estado de error
          setQuotaInfo(null);
        }
      }
    } catch (error) {
      console.error('Error al cargar información de cuota:', error);
      setQuotaInfo(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadQuotaInfo();
  }, [refreshTrigger]);

  if (loading) {
    return (
      <div className="card border-0 shadow-sm">
        <div className="card-body">
          <div className="d-flex align-items-center">
            <div className="spinner-border spinner-border-sm text-primary me-2" role="status">
              <span className="visually-hidden">Cargando...</span>
            </div>
            <small className="text-muted">Cargando cuota...</small>
          </div>
        </div>
      </div>
    );
  }

  if (!quotaInfo) {
    return null;
  }

  // Obtener estado y clases de la cuota usando configuración centralizada
  const quotaStatus = getQuotaStatus(quotaInfo.available);
  const quotaClasses = getQuotaClasses(quotaInfo.available);

  return (
    <div className="card border-0 shadow-sm">
      <div className="card-body p-3">
        {/* Información principal de cuota */}
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div className="d-flex align-items-center">
            <i className="bi bi-graph-up me-2 text-info"></i>
            <div>
              <h6 className="mb-0 fw-semibold">Cuota de Documentos</h6>
              <div className={`fw-bold ${quotaClasses.text}`}>
                {quotaInfo.available} restantes
              </div>
            </div>
          </div>
          <div className="text-end">
            <span className={`badge ${
              quotaStatus.status === 'healthy' ? 'bg-success' : 
              quotaStatus.status === 'critical' ? 'bg-danger' : 'bg-warning'
            }`}>
              {quotaStatus.label}
            </span>
          </div>
        </div>
 
        {/* Botón de acción */}
        {quotaStatus.status !== 'healthy' && (
          <div className={`alert ${quotaClasses.alert} py-2 px-3 mb-0`}>
            <div className="d-flex align-items-center justify-content-between">
              <small>
                {quotaStatus.status === 'critical'
                  ? `¡Solo quedan ${quotaInfo.available} documentos!`
                  : `Quedan ${quotaInfo.available} documentos`
                }
              </small>
              <a href="/comprar-documentos" className={`btn btn-sm ${quotaClasses.btn}`}>
                <i className="bi bi-plus-circle me-1"></i>
                {quotaStatus.status === 'critical' ? 'Comprar YA' : 'Comprar más'}
              </a>
            </div>
          </div>
        )} 
      </div>
    </div>
  );
};

export default UserQuotaDisplay;
